<template>
  <div
    class="submissions-app rubric-submissions"
    :class="{'open':showFilter, 'closed': !showFilter}"
  >
    <div class="title">
      <h1>Dashboard</h1>
      <div class="tasks--menu">
        <span v-for="(item, key) in menu" :key="key">
          <a :href="item.path" :class="{'active': activeItem == ('/' + item.path)}">{{ item.title }}</a>
        </span>
      </div>
    </div>
    <div
      ref="sidebar-facets"
      class="sidebar-left"
      :class="{'open':showFilter, 'closed': !showFilter}"
    >
      <div class="facets-title">
        <h1>Submissions</h1>
      </div>
      <div class="facets-data">
        <div class="search-bar">
          <md-field class="search">
            <label>Search</label>
            <md-icon>search</md-icon>
            <md-input
              @keyup="searchBarTyping = true"
              @keyup.enter="searchBarTyping = false; goSearch()"
              v-model="searchBar"
            ></md-input>
            <md-button
              v-show="searchBarTyping == true"
              @click="searchBarTyping = searchBar == '' ? true : false; goSearch()"
              class="md-button search"
            >
              Search
              <md-icon>arrow_right_alt</md-icon>
            </md-button>
            <md-button
              v-show="searchBarTyping == false"
              @click="searchBarTyping = true; searchBar = ''; goSearch()"
              class="md-icon-button clear"
            >
              <md-icon class="clear">close</md-icon>
            </md-button>
          </md-field>
          <md-button @click="toogleSidebar()" class="filter">
            <md-icon>filter_list</md-icon>
            <span>Filter</span>
            <md-icon class="close" :class="{'active':showFilter}">close</md-icon>
          </md-button>
        </div>
        <div class="other-filters" :class="{'open':showFilter, 'closed': !showFilter}">
          <div class="filters">
            <div class="data" :key="index" v-for="(facet, index) in facets_ordered">
              <div
                class="facet-wrapper"
                :key="field"
                v-for="(item, field) in facet"
                :class="{'collapsed':collapsed[field]}"
              >
                <a v-if="field === 'submission_title'" @click="toggleFilterItem(field)">
                  Title
                  <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                </a>
                <a v-else-if="field === 'submission_status'" @click="toggleFilterItem(field)">
                  Status
                  <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                </a>
                <a v-else-if="field === 'rubric_submission_type'" @click="toggleFilterItem(field)">
                  Type
                  <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                </a>
                <a v-else-if="field === 'submission_user_role'" @click="toggleFilterItem(field)">
                  Roles
                  <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                </a>
                <a v-else-if="field === 'submission_user_group'" @click="toggleFilterItem(field)">
                  Group
                  <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                </a>
                <a v-else @click="toggleFilterItem(field)">
                  {{ field }}
                  <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                </a>
                <div class="facet" :class="field" v-show="collapsed[field]">
                  <md-checkbox
                    :ref="field + '_' + index"
                    :key="index"
                    v-for="(data, index) in item"
                    @change="updateData(data.url)"
                    v-model="data.values.active"
                    :value="data.values.value"
                  >{{ transformValue(field, data.values.value) }}
                  </md-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <md-button class="clear" v-on:click="clearSearchResult">Reset</md-button>
            <md-button class="md-raised apply" v-on:click="applySearch">Apply</md-button>
          </div>
        </div>
      </div>
    </div>

    <div class="results_count">
      <div class="count">{{ result_count }} Result{{ result_count > 1 ? 's' : '' }}</div>
      <div class="breadcrumbs">
        <div :key="index" v-for="(facet, index) in facets">
          <div class="breadcrumbs-group" :key="field" v-for="(item, field) in facet">
            <div :key="index" v-for="(data, index) in item">
              <div v-if="data.values.active" class="breadcrumb">
                <span>{{ transformValue(field, data.values.value) }}</span>
                <md-button class="md-icon-button" @click="removeFacetsAction(data)">
                  <md-icon>close</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </div>
        <md-button v-if="breadcrumbs.length" class="clear" v-on:click="clearSearchResult">Clear all</md-button>
      </div>
    </div>
    <div class="result">
      <div class="mobile" v-if="$mq != 'large' && $mq != 'xlarge'">
        <div class="row" :key="i" v-for="(item, i) in filtered"
             :data-uuid="item.submission_uuid"
             :class="{'active': openedComments[item.submission_uuid], 'grey': item.submission_status === 'Review Needed'}"
        >
          <div class="data-wrapper">
            <div :key="key" v-for="(name, key) in columns" :class="key">
              <span v-if="key === 'submission_learner'">
                <span class="title">Learner: </span>
                <span>{{ item[key] }}</span>
              </span>
              <span v-else-if="key === 'submission_title'">
                <span class="title">Title: </span>
                 <a v-if="item.rubric_submission_type === 'assignment'"
                   :href="getSubmissionUrl(item)">
                  <span v-html="item[key]"></span>
                </a>
                <a v-else :href="getSubmissionUrl(item)">
                  <span v-html="getActivityTitle(item, key)"></span>
                </a>
              </span>
              <span v-else-if="key === 'form'">
                <span class="title">Title: </span>
                <span> {{ transformValue('form', item.section) }} </span>
              </span>
              <span v-else-if="key === 'rubric_submission_type'">
              </span>
              <span v-else-if="key === 'submission_date'">
                <span class="title">Date: </span>
                <span v-html="item[key]"></span>
              </span>
              <span v-else-if="key === 'submission_status'">
                <span class="title">Status: </span>
                 <span
                   v-if="item.form === 'field_set_form'
                && item.submission_status === 'Review Needed'"
                 >In Progress</span>
                <span> {{ item[key] }}</span>
              </span>
              <span v-else-if="key === 'score'">
                <span class="title">Score: </span>
                <span v-if="item.section === 'field_set_form'">N/A</span>
                <span v-else-if="item.field_evaluation_type === 'no_score'">N/A</span>
                <span v-else-if="item[key] === '0'">Not scored</span>
                <span v-else-if="item[key] === ''">Not scored</span>
                <span v-else-if="!(item.rubric_submission_type === 'assignment') && item[key] != '0'">
                  {{ item[key] }}%
                </span>
                <span v-else-if="item.rubric_submission_type === 'assignment'">N/A</span>
              </span>
              <span v-else-if="key === 'submission_uuid'">
              </span>
              <span v-else v-html="item[key]"></span>
            </div>

          </div>
          <div class="view-more">
            <a :href="getSubmissionUrl(item)">View Submission</a>
          </div>
        </div>
      </div>

      <div class="table" v-else>
        <div class="header">
          <div v-for="(name, key) in columns" :class="key" :key="key">
            <span v-if="key == 'id'">{{ name }}</span>
            <a v-else @click="toggleSort(key)" :class="{'active':sorted[key]}">
              {{ name }}
              <md-icon
                v-if="key !== 'submission_uuid' "
              >{{ sorted[key] === 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down' }}
              </md-icon>
            </a>
          </div>
        </div>

        <div class="row" :key="i" v-for="(item, i) in filtered"
             :data-uuid="item.submission_uuid"
             :class="{'active': openedComments[item.submission_uuid], 'grey': item.submission_status === 'Review Needed'}"
        >
          <div class="data">
            <div :key="key" v-for="(name, key) in columns" :class="key">
              <span v-if="key === 'form'">{{ transformValue('form', item.section) }}</span>
              <span v-else-if="key === 'submission_uuid' && item.submission_comments != 0">
                <a @click="toggleComments(item.submission_uuid)" target="_blank">
                  {{ toggleCommentsLabel(item.submission_uuid) }}
                  <md-icon>{{ toggleIcon(item.submission_uuid) }}</md-icon>
                </a>
              </span>
              <span
                v-else-if="key === 'submission_uuid' && item.submission_comments == 0"
              >No comments yet</span>
              <span
                v-else-if="key === 'submission_status' && item.form === 'field_set_form' && item.submission_status === 'Review Needed'"
              >In Progress</span>

              <span v-else-if="key === 'score' && item.section === 'field_set_form'">N/A</span>
              <span v-else-if="key === 'score' && item.field_evaluation_type === 'no_score'">N/A</span>
              <span v-else-if="key === 'score' && item[key] === '0'">Not scored</span>
              <span v-else-if="key === 'score' && item[key] === ''">Not scored</span>
              <span
                v-else-if="key === 'score' && !(item.rubric_submission_type === 'assignment') && item[key] != '0'"
              >{{ item[key] }}%</span>
              <span v-else-if="key === 'score' && item.rubric_submission_type === 'assignment'">N/A</span>
              <span v-else-if="key === 'submission_title'">
                <a
                  v-if="item.rubric_submission_type === 'assignment'"
                  :href="'/assignment-submission/' + item.id_1 "
                >
                  <span v-html="item[key]"></span>
                </a>
                <a v-else :href="'/activity-submission/' + item.id ">
                  <span v-html="getActivityTitle(item, key)"></span>
                </a>
              </span>
              <span v-else v-html="item[key]"></span>
            </div>
          </div>

          <div v-if="showComments" class="comments">
            <ul>
              <li v-for="(comment, key) in showComments[item.submission_uuid]">
                <div class="comment">
                  <div class="user">
                    <div class="user-fullname">{{ showComments[item.submission_uuid][key].user }}</div>&nbsp;commented&nbsp;on&nbsp;
                    <div
                      class="activity-name"
                    >{{ replaceNodeTitleToken(showComments[item.submission_uuid][key].element, item.submission_title) }}
                    </div>
                    :
                  </div>
                  <div class="text" v-html="showComments[item.submission_uuid][key].comment"></div>
                </div>
                <div class="changed">{{ showComments[item.submission_uuid][key].date }} days ago</div>
                <div class="go-to-comment">
                  <a
                    v-if="showComments[item.submission_uuid][key].entity_type === 'assignment_submission'"
                    :href="'/assignment-submission/' + showComments[item.submission_uuid][key].entity_id"
                  >Go to comment</a>
                  <a
                    v-else
                    :href="'/activity-submission/' + item.id + '/#' + showComments[item.submission_uuid][key].commentId"
                  >Go to comment</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="pagination">
        <pagination
          v-model="currentPage"
          :records="+pager.total_items"
          :per-page="+pager.items_per_page"
          :options="{chunk:7, chunksNavigation:true, edgeNavigation:true}"
          @paginate="pagerAction"
        ></pagination>
      </div>
    </div>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import Spinner from "./components/Spinner.vue";
import Vue from "vue";
import Submissions from "./Submissions";
import MenuMixin from "./MenuMixin";

export default {
  name: "RubricSubmissions",
  mounted() {
    this.activeItem = window.location.pathname;
  },
  mixins: [Submissions, MenuMixin],
  computed: {
    resultExist() {
      return this.isDataFetched && this.filtered && this.filtered.length > 0;
    },
    menu() {
      let menu = this.getMainMenu(this.$mq)
      .filter((item) => {
        if (item.path == "rubric-submissions") {
          return item;
        }
      });
      if (menu.length) {
        let submenu = menu[0].items.filter((item) => {
          if (item.restricted) {
            return item.access.call();
          } else {
            return true;
          }
        });
        return submenu;
      }
    },

    facets_ordered() {
      var ordering = {}, // map for efficient lookup of sortIndex
        sortOrder = [
          "submission_title",
          "competency",
          "form",
          "submission_status",
          "rubric_submission_type",
          "submission_user_group",
          "submission_user_role",
        ];
      for (var i = 0; i < sortOrder.length; i++) {
        ordering[sortOrder[i]] = i;
      }
      return this.facets.sort((a, b) => {
        return (
          ordering[Object.keys(a)[0]] - ordering[Object.keys(b)[0]] ||
          Object.keys(a)[0].localeCompare(Object.keys(b)[0])
        );
      });
    },
  },
  components: {
    Spinner,
  },

  data() {
    let cols = window.drupalSettings.controller.submissions_settings.columns;
    let sorted = {};
    let keys = Object.keys(cols);
    for (let i = 0; i < keys.length; i++) {
      sorted[keys[i]] = 0;
    }
    return {
      collapsed: {},
      lastUrl: "/rest/rubric-submissions?_format=json",
      facets: [],
      activeFacets: {},
      pager: [],
      currentPage: 1,
      searchBar: "",
      searchBarTyping: true,
      filtered: [],
      columns: cols,
      sorted: sorted,
      showLoader: false,
      showFilter: false,
      small: false,
      showComments: [],
      openedComments: [],
      activeItem: false,
      isDataFetched: false
    };
  },
  watch: {},
  methods: {
    log(msg) {
      console.log(msg);
    },
    getSubmissionUrl(item) {
      if (item.rubric_submission_type === 'assignment') {
        return '/assignment-submission/' + item.id_1;
      }
      else {
        return '/activity-submission/' + item.id;
      }
    },
    replaceNodeTitleToken(value, item) {
      return value.replace(/\[([a-z_:-]+)\]/g, item);
    },
    getFormName(field, val) {
      let name = "";
      if (val !== "activity_form") {
        let formName = this.transformValue(field, val);
        if (formName != "") {
          name += " - " + formName;
        }
      }
      return name;
    },
    getActivityTitle(item, key) {
      return item[key] + this.getFormName('form', item.section);
    },
    toggleCommentsLabel(activitySubmissionId) {
      return this.openedComments[activitySubmissionId]
        ? "Hide comments"
        : "Show comments";
    },
    toggleIcon(activitySubmissionId) {
      return this.openedComments[activitySubmissionId]
        ? "arrow_drop_up"
        : "arrow_drop_down";
    },
    toggleComments(activitySubmissionId) {
      if (this.showComments.hasOwnProperty(activitySubmissionId)) {
        Vue.set(
          this.openedComments,
          activitySubmissionId,
          !this.openedComments[activitySubmissionId]
        );
      } else {
        this.showLoader = true;
        this.getComment(activitySubmissionId);
        Vue.set(
          this.openedComments,
          activitySubmissionId,
          !this.openedComments[activitySubmissionId]
        );
      }
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        return text;
      });
    },
    getComment(activitySubmissionId) {
      var self = this;
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        fetch(
          "/jsonapi/catch_comment/catch_comment?include=user&filter[submission_uuid]=" +
          activitySubmissionId,
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          }
        )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          let users = {};
          if (json.included) {
            json.included.forEach((data) => {
              users[data.id] =
                data.attributes.field_first_name +
                " " +
                data.attributes.field_last_name;
            });
          }
          if (json.hasOwnProperty("data")) {
            let filtered = json.data.filter((item) => {
              // Exclude empty comments and comments on video.
              if (
                item.attributes.comment != null &&
                item.attributes.meta == null
              ) {
                return true;
              }
            });
            let decoratedData = filtered.map((item) => {
              if (item.attributes.comment != null) {
                let date = Date.parse(item.attributes.changed);
                return {
                  date: Math.round(
                    (Date.now() - date) / (24 * 60 * 60 * 1000)
                  ),
                  comment: item.attributes.comment.value,
                  commentId: item.id,
                  user: users[item.relationships.user.data.id],
                  element:
                    item.attributes.element_label != null
                      ? item.attributes.element_label
                      : "Submission",
                  entity_type: item.attributes.entity_type,
                  entity_id: item.attributes.entity_id,
                };
              }
            });
            //Vue.set(self.openedComments, activitySubmissionId, false);
            Vue.set(self.showComments, activitySubmissionId, decoratedData);
            this.showLoader = false;
          }
        });
      });
    },
    toggleSort(column) {
      let direction;
      let keys = Object.keys(this.sorted);
      for (let i = 0; i < keys.length; i++) {
        if (keys[i] == column) {
          direction = "DESC";
          if (this.sorted[column]) {
            direction = this.sorted[column] === "DESC" ? "ASC" : "DESC";
          }
          this.sorted[keys[i]] = direction;
        } else {
          this.sorted[keys[i]] = 0;
        }
      }

      let url = this.updateUrl({
        sort_by: column === "score" ? "activity_submission_score" : column,
        sort_order: direction.toUpperCase(),
      });
      this.updateData(url);
    },
    clearSearchResult() {
      this.searchBar = "";
      this.searchBarTyping = true;
      this.lastUrl = "/rest/rubric-submissions";
      this.fetchInitialData();
      this.toogleSidebar(0);
    },
    fetchInitialData() {
      this.showLoader = true;
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      fetch("/rest/rubric-submissions?_format=json", options)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.isDataFetched = true;
        this.filtered = data.search_results;
        this.pager = data.pager;
        this.facets = this.decorateFacets(data.facets);
        this.showLoader = false;
      })
      .catch(() => {
        this.showLoader = false;
      });
    },
    updateData(url) {
      this.showLoader = true;
      this.lastUrl = url;
      fetch(url)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.filtered = data.search_results;
        this.pager = data.pager;
        this.facets = this.decorateFacets(data.facets);
        this.showLoader = false;
        this.currentPage = this.pager.current_page + 1;
      })
      .catch(() => {
        this.showLoader = false;
      });
    },
    transformValue(field, val) {
      if (field === "form") {
        switch (val) {
          case "activity_form":
            return "Activity";
          case "field_set_form":
            return "Set";
          case "field_go_form":
            return "Go";
        }
      }
      return val;
    },
    getUrlByParams(params) {
      let arr = [];
      for (let [k, v] of Object.entries(params)) {
        if (v) {
          // Sort order must be uppercase
          if (k === "sort_order") {
            v = v.toUpperCase();
          }
          arr.push(k + "=" + v);
        }
      }
      return "/rest/rubric-submissions?" + arr.join("&");
    },
  },
};
</script>

<style lang="scss">
.submissions-app.rubric-submissions {
  .no-data {
    padding: 1rem;
  }

  .result {
    border-radius: 20px;
    background: #ffffff;
    padding: 0px !important;
    font-family: "Source Sans Pro" !important;
    overflow: hidden;

    > div {
      width: 100%;
    }

    .activity {
      width: 280px;
    }
  }

  .table {
    .header {
      display: flex;
      font-family: "fi lson-soft ", sans-serif;
      text-transform: uppercase;
      padding: 20px;
      border-bottom: 1px solid rgb(224, 224, 224);

      > div {
        padding-left: 1%;
        padding-right: 1%;
        width: 18%;
        background: transparent !important;
      }

      a {
        display: flex;
        color: rgb(60, 60, 60) !important;
        font-weight: normal !important;

        i {
          font-size: 20px !important;
        }

        &:hover {
          text-decoration: none !important;
          cursor: pointer;
        }
      }

      .submission_title {
        flex-basis: unset !important;
        margin: 0px !important;
        max-width: unset !important;
        min-width: 200px;
      }

      .competency {
        min-width: 200px;
      }

      .submission_uuid {
        min-width: 150px;
      }

      .score {
        width: 100px;
      }
    }

    .row {
      border-bottom: 1px solid rgb(224, 224, 224);
      //margin: 20px;

      .comments {
        display: none;
      }

      &.active {
        .comments {
          display: block;
        }

        margin-top: 0px;
        margin-left: 0px;
        margin-bottom: 0px;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
        border-left: 6px solid $blue-dark;
      }

      &.grey {
        background: rgb(245, 245, 245);
      }

      .data {
        display: flex;
        align-items: center;
        padding: 10px;

        > div {
          padding-left: 1%;
          padding-right: 1%;
          width: 18%;
          background: transparent !important;
        }

        .submission_title {
          min-width: 200px;
        }

        .rubric_submission_type {
          text-transform: capitalize;
        }

        .competency {
          min-width: 200px;
        }

        .submission_uuid {
          min-width: 150px;

          a {
            color: $blue-active !important;

            i {
              color: $blue-active !important;
            }

            &:hover {
              text-decoration: none;
              cursor: pointer;
            }
          }
        }

        .score {
          width: 100px;
        }

        .submission_title {
          flex-basis: unset;
          margin: 0px;
          max-width: unset;

          a {
            color: $blue-active !important;
          }
        }
      }
    }
  }

  .comments {
    ul {
      li {
        display: flex;
        border-top: 1px solid rgb(224, 224, 224);
        margin-left: -25px;
        padding: 0 10px;

        .comment .user {
          display: flex;
          font-weight: 700;
        }

        .comment .activity-name {
          max-width: 250px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .go-to-comment {
          background: $blue-dark;
          border-radius: 20px;
          padding: 10px;
          display: flex;
          align-self: center;
          align-items: center;

          a {
            font-size: 16px;
            text-align: center;
            color: #ffffff !important;
            display: block;
            margin: 0 auto;

            &:hover {
              text-decoration: none;
              cursor: pointer;
            }
          }
        }

        > div {
          display: flex;
          align-self: center;
          padding: 10px;
        }

        > div.comment {
          width: 68%;
          flex-direction: column;
        }

        > div.changed {
          width: 12%;
          color: #686868;
          display: block;
          margin: 0 auto;
        }

        > div.go-to-comment {
          width: 150px;
        }
      }
    }
  }

  .VuePagination {
    margin-bottom: 20px;

    ul.pagination {
      margin-top: 0;
    }

    a {
      color: $blue-dark !important;

      &:hover {
        color: $blue-active !important;
      }

      &.active {
        color: rgba($blue-dark, 0.5) !important;
      }
    }
  }
}
</style>

